// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DecisionAlertsPanel_panel__L1qgM {
  padding: 18px;
}

.DecisionAlertsPanel_header__IrKX2 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 18px;
}

.DecisionAlertsPanel_header__IrKX2 h3 {
  margin: 0 0 5px;
  color: #173f56;
  font-size: 1rem;
}

.DecisionAlertsPanel_header__IrKX2 p {
  margin: 0;
  color: #71808b;
  font-size: 0.8rem;
}

.DecisionAlertsPanel_scopeToggle__glsyc {
  display: inline-flex;
  gap: 6px;
  padding: 4px;
  border: 1px solid #d8e0e6;
  border-radius: 10px;
  background: #f7f9fa;
}

.DecisionAlertsPanel_scopeToggle__glsyc button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #546875;
  font: inherit;
  font-size: 0.82rem;
  cursor: pointer;
}

.DecisionAlertsPanel_scopeToggle__glsyc button span {
  min-width: 22px;
  padding: 1px 6px;
  border-radius: 999px;
  background: #e9eef2;
  color: #52636f;
  text-align: center;
  font-size: 0.72rem;
  font-weight: 700;
}

.DecisionAlertsPanel_scopeToggle__glsyc .DecisionAlertsPanel_activeScope__I7pAm {
  background: #2c6078;
  color: #fff;
  font-weight: 700;
}

.DecisionAlertsPanel_scopeToggle__glsyc .DecisionAlertsPanel_activeScope__I7pAm span {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.DecisionAlertsPanel_list__9i5ab {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.DecisionAlertsPanel_alertCard__XN5oO {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr);
  gap: 10px;
  padding: 13px 15px;
  border: 1px solid;
  border-radius: 10px;
}

.DecisionAlertsPanel_lowAlert__hkCHZ {
  border-color: #f2c5d5;
  background: #fff5f8;
}

.DecisionAlertsPanel_highAlert__ZX2BA {
  border-color: #cfe7da;
  background: #f4fbf7;
}

.DecisionAlertsPanel_alertDot__OCsUj {
  width: 7px;
  height: 7px;
  margin-top: 7px;
  border-radius: 50%;
  background: #e71873;
}

.DecisionAlertsPanel_highAlert__ZX2BA .DecisionAlertsPanel_alertDot__OCsUj {
  background: #2fac68;
}

.DecisionAlertsPanel_alertBody__Z3ygX {
  min-width: 0;
}

.DecisionAlertsPanel_alertTitle__ZvwcY {
  color: #263746;
  font-size: 0.88rem;
  line-height: 1.35;
}

.DecisionAlertsPanel_alertTitle__ZvwcY strong {
  font-weight: 700;
}

.DecisionAlertsPanel_bienveillance__rkOVD {
  color: #d8aa12;
}

.DecisionAlertsPanel_engagement__86ilZ {
  color: var(--upcare-value-engagement);
}

.DecisionAlertsPanel_faireEquipe__j3Jsi {
  color: var(--upcare-value-faire-equipe);
}

.DecisionAlertsPanel_respect__UWMRi {
  color: var(--upcare-value-respect);
}

.DecisionAlertsPanel_alertMeta__oPp0r {
  margin: 4px 0 0;
  color: #627584;
  font-size: 0.78rem;
}

.DecisionAlertsPanel_alertMeta__oPp0r strong {
  color: #263746;
  font-weight: 700;
}

.DecisionAlertsPanel_actionButton__YROrk {
  margin-top: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #2c6078;
  font: inherit;
  font-size: 0.78rem;
  text-align: left;
  cursor: pointer;
}

.DecisionAlertsPanel_actionButton__YROrk:hover,
.DecisionAlertsPanel_actionButton__YROrk:focus-visible {
  text-decoration: underline;
  outline: none;
}

.DecisionAlertsPanel_empty__JchQE {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #71808b;
  text-align: center;
  font-size: 0.86rem;
}

@media (max-width: 760px) {
  .DecisionAlertsPanel_header__IrKX2 {
    flex-direction: column;
  }

  .DecisionAlertsPanel_scopeToggle__glsyc {
    width: 100%;
  }

  .DecisionAlertsPanel_scopeToggle__glsyc button {
    flex: 1 1;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/DecisionAlertsPanel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":[".panel {\n  padding: 18px;\n}\n\n.header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n  margin-bottom: 18px;\n}\n\n.header h3 {\n  margin: 0 0 5px;\n  color: #173f56;\n  font-size: 1rem;\n}\n\n.header p {\n  margin: 0;\n  color: #71808b;\n  font-size: 0.8rem;\n}\n\n.scopeToggle {\n  display: inline-flex;\n  gap: 6px;\n  padding: 4px;\n  border: 1px solid #d8e0e6;\n  border-radius: 10px;\n  background: #f7f9fa;\n}\n\n.scopeToggle button {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 12px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #546875;\n  font: inherit;\n  font-size: 0.82rem;\n  cursor: pointer;\n}\n\n.scopeToggle button span {\n  min-width: 22px;\n  padding: 1px 6px;\n  border-radius: 999px;\n  background: #e9eef2;\n  color: #52636f;\n  text-align: center;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.scopeToggle .activeScope {\n  background: #2c6078;\n  color: #fff;\n  font-weight: 700;\n}\n\n.scopeToggle .activeScope span {\n  background: rgba(255, 255, 255, 0.2);\n  color: #fff;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.alertCard {\n  display: grid;\n  grid-template-columns: 10px minmax(0, 1fr);\n  gap: 10px;\n  padding: 13px 15px;\n  border: 1px solid;\n  border-radius: 10px;\n}\n\n.lowAlert {\n  border-color: #f2c5d5;\n  background: #fff5f8;\n}\n\n.highAlert {\n  border-color: #cfe7da;\n  background: #f4fbf7;\n}\n\n.alertDot {\n  width: 7px;\n  height: 7px;\n  margin-top: 7px;\n  border-radius: 50%;\n  background: #e71873;\n}\n\n.highAlert .alertDot {\n  background: #2fac68;\n}\n\n.alertBody {\n  min-width: 0;\n}\n\n.alertTitle {\n  color: #263746;\n  font-size: 0.88rem;\n  line-height: 1.35;\n}\n\n.alertTitle strong {\n  font-weight: 700;\n}\n\n.bienveillance {\n  color: #d8aa12;\n}\n\n.engagement {\n  color: var(--upcare-value-engagement);\n}\n\n.faireEquipe {\n  color: var(--upcare-value-faire-equipe);\n}\n\n.respect {\n  color: var(--upcare-value-respect);\n}\n\n.alertMeta {\n  margin: 4px 0 0;\n  color: #627584;\n  font-size: 0.78rem;\n}\n\n.alertMeta strong {\n  color: #263746;\n  font-weight: 700;\n}\n\n.actionButton {\n  margin-top: 8px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #2c6078;\n  font: inherit;\n  font-size: 0.78rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.actionButton:hover,\n.actionButton:focus-visible {\n  text-decoration: underline;\n  outline: none;\n}\n\n.empty {\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #71808b;\n  text-align: center;\n  font-size: 0.86rem;\n}\n\n@media (max-width: 760px) {\n  .header {\n    flex-direction: column;\n  }\n\n  .scopeToggle {\n    width: 100%;\n  }\n\n  .scopeToggle button {\n    flex: 1 1 0;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `DecisionAlertsPanel_panel__L1qgM`,
	"header": `DecisionAlertsPanel_header__IrKX2`,
	"scopeToggle": `DecisionAlertsPanel_scopeToggle__glsyc`,
	"activeScope": `DecisionAlertsPanel_activeScope__I7pAm`,
	"list": `DecisionAlertsPanel_list__9i5ab`,
	"alertCard": `DecisionAlertsPanel_alertCard__XN5oO`,
	"lowAlert": `DecisionAlertsPanel_lowAlert__hkCHZ`,
	"highAlert": `DecisionAlertsPanel_highAlert__ZX2BA`,
	"alertDot": `DecisionAlertsPanel_alertDot__OCsUj`,
	"alertBody": `DecisionAlertsPanel_alertBody__Z3ygX`,
	"alertTitle": `DecisionAlertsPanel_alertTitle__ZvwcY`,
	"bienveillance": `DecisionAlertsPanel_bienveillance__rkOVD`,
	"engagement": `DecisionAlertsPanel_engagement__86ilZ`,
	"faireEquipe": `DecisionAlertsPanel_faireEquipe__j3Jsi`,
	"respect": `DecisionAlertsPanel_respect__UWMRi`,
	"alertMeta": `DecisionAlertsPanel_alertMeta__oPp0r`,
	"actionButton": `DecisionAlertsPanel_actionButton__YROrk`,
	"empty": `DecisionAlertsPanel_empty__JchQE`
};
export default ___CSS_LOADER_EXPORT___;
